import { h2Styles, h4Styles, h6Styles, pStyles } from 'components/reusable-css';
import styled, { css } from 'styled-components';

export const Features = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 25px 2.5em 0 3em;
  padding-bottom: 4em;
  min-height: 200%;
  background: ${(props) => props.theme.serverSizeCard.features.backgroundColor};
`;

export const Feature = styled.div`
  display: flex;
  line-height: 2em;
  font-size: ${(props) => props.theme.default?.p};
  ${(props) => pStyles(props.theme.resolutions)};
  padding-top: 5px;
  i {
    color: ${(props) => props.theme.primaryColor};
    margin-right: 6px;
  }
`;

export const ServerSizeCardSC = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background: ${(props) => props.theme.gray.shadeF};
  width: 100%;
  height: auto;
  border-radius: 10px;
  border: 2px solid ${(props) => props.theme.serverSizeCard.borderColor};
  overflow: hidden;
  cursor: pointer;
  transition: all 150ms ease;

  &:hover {
    background: ${(props) => props.theme.serverSizeCard.hoverBackgroundColor};
    border-color: ${(props) => props.theme.serverSizeCard.hoverBorderColor};

    ${Features} {
      background: ${(props) => props.theme.serverSizeCard.features.hoverBackgroundColor};
    }
  }

  ${(props) =>
    props.selected &&
    css`
      border-color: ${(props) => props.theme.primaryColor};
    `};
`;

export const Tag = styled.div`
  display: flex;
  visibility: ${(props) => (props.showTag ? 'visible' : 'hidden')};
  align-items: center;
  justify-content: center;
  align-self: flex-end;
  background: ${(props) => props.theme.serverSizeCard.tag.backgroundColor};
  color: ${(props) => props.theme.gray.shadeF};
  height: 25px;
  width: 200px;
  border-radius: 0 10px 0 20px;
  position: relative;
  top: -2px;
  right: -2px;
  font-style: italic;
  font-weight: bold;
  font-size: ${(props) => props.theme.default?.p};
  ${(props) => pStyles(props.theme.resolutions)};

`;

export const NameContainer = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
  padding: 0px 15px;
  padding-top: 8px;
`;

export const Name = styled.div`
  padding: 0px 5px;
  padding-top: 20px;
  display: flex;
  font-size: ${(props) => props.theme.default?.h4};
  ${(props) => h4Styles(props.theme.resolutions)};

`;

export const Price = styled.div`
  display: flex;
  flex-direction: column;
  margin: 6px 0 23px;
  padding: 0 20px;
`;

export const PerMonth = styled.div`
  display: flex;
  align-items: baseline;
  font-weight: 900;
  font-size: ${(props) => props.theme.default?.h6};
  ${(props) => h6Styles(props.theme.resolutions)};

`;

export const PriceUnit = styled.div`
  display: flex;
  font-size: ${(props) => props.theme.default?.h2};
  ${(props) => h2Styles(props.theme.resolutions)};
  font-weight: bolder;
`;
export const Add = styled.span`
  font-size: 23px;
  font-weight: bolder;
  margin-left: 5px;
  margin-right: 6px; 
  margin-bottom: 5px;
`;
export const SelectedTag = styled.div`
  display: flex;
  background: ${(props) => props.theme.serverSizeCard.selectedTag.backgroundColor};
  border-radius: 0;
  border-top-left-radius: 20px;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.gray.shadeF};
  height: 40px;
  width: 220px;
  position: absolute;
  bottom: -2px;
  right: -2px;
  font-size: ${(props) => props.theme.default?.p};
  ${(props) => pStyles(props.theme.resolutions)};

  i {
    margin-right: 6px;
    margin-bottom: 8px;
  }
`;
